var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStepicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_21007",
    "data-name": "\\uADF8\\uB8F9 21007",
    transform: "translate(-659 -2818)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uD0C0\\uC6D0_1183",
    "data-name": "\\uD0C0\\uC6D0 1183",
    transform: "translate(659 2818)",
    fill: "#ff6a13",
    stroke: "#ff6a13",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "_",
    "data-name": "?",
    transform: "translate(669 2833)",
    fill: "#fff",
    fontSize: 12,
    fontFamily: "Helvetica-Bold, Helvetica",
    fontWeight: 700,
    letterSpacing: "-0.04em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -3.665,
    y: 0
  }, "?")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepicon);
export default __webpack_public_path__ + "static/media/stepicon.d3a3bd86587428ee823388865729626d.svg";
export { ForwardRef as ReactComponent };